const BRAND = "THE TYRE CO.";
const ENTITY = "TTC";
const EMAIL = "trade1ttc@gmail.com";
const ADDRESS = "H No 302, Tower B1, Adani Aangan, Sector 88/89A, Gurugram, Haryana 122505, India";
const UPDATED = "Last updated: June 2026";

export const POLICIES = {
  terms: {
    title: "Terms & Conditions",
    intro: `These terms apply to every purchase on this website, operated by ${ENTITY} under the brand ${BRAND}. By placing an order you agree to them.`,
    sections: [
      ["About us", [`${BRAND} is a brand of ${ENTITY}. GSTIN: 06FVBPS5036P1ZZ.`, `Support: ${EMAIL}.`, `~Registered address: ${ADDRESS}`]],
      ["Prices and payment", [
        "Product prices are shown in US dollars (USD) with an approximate Indian rupee (INR) equivalent for reference.",
        "All payments are charged in INR at the exchange rate shown at checkout. The INR total shown at checkout, including shipping, is the final amount payable.",
        "Payments are processed securely by Cashfree Payments. We never see or store your card, UPI or bank details.",
      ]],
      ["Orders and availability", [
        "All orders are subject to stock availability and confirmation. If an item becomes unavailable or was listed with an obvious pricing error, we will contact you and refund the amount paid in full.",
        "Special-order and on-order items are sourced specifically for you and cannot be cancelled or returned once ordered from our supplier.",
      ]],
      ["Fitment", [
        "Size, load and speed information and our vehicle guidance are provided for reference. You are responsible for confirming that the tyre is suitable for your vehicle before purchase and fitment.",
        "Tyres should be mounted and balanced by a qualified professional.",
      ]],
      ["Warranty", [
        "Manufacturer warranty, where applicable, is provided by the tyre manufacturer, not by us. We will help you raise a warranty claim with the manufacturer.",
        "Tyres not manufactured in India are not eligible for warranty claims through us.",
      ]],
      ["Liability", ["To the extent permitted by law, our liability for any order is limited to the amount paid for that order. We are not liable for damage caused by incorrect fitment, misuse, improper inflation or road hazards."]],
      ["Governing law", ["These terms are governed by the laws of India. Disputes are subject to the exclusive jurisdiction of the courts at Gurugram, Haryana."]],
    ],
  },
  returns: {
    title: "Refund & Cancellation Policy",
    intro: "Please read this policy before ordering. Tyres are high-value, made-to-measure items, so returns are limited.",
    sections: [
      ["Refunds", [
        "Refunds are offered only for manufacturing defects, and are subject to inspection after delivery.",
        `To report a defect, email ${EMAIL} with your order number, clear photos of the tyre and the defect, and the DOT/manufacturing code. Please report it as soon as you notice it and before the tyre is driven on further.`,
        "If the inspection confirms a manufacturing defect, we will replace the tyre or refund the amount paid for it, at our option.",
        "Approved refunds are made to the original payment method. Banks usually take 5–7 working days to show the credit.",
      ]],
      ["No returns", [
        "We do not accept returns for change of mind, wrong size ordered, or fitment issues.",
        "On-order and special-order items cannot be returned or cancelled.",
        "Tyres that have been damaged by fitment, misuse, impact or road hazards are not eligible for a refund.",
      ]],
      ["Cancellations", [`In-stock orders can be cancelled by emailing ${EMAIL} before the order is dispatched; we will refund the full amount. Once an order is dispatched it cannot be cancelled. [TO CONFIRM: cancellation before dispatch allowed]`]],
      ["Damaged in transit", [`If a tyre arrives visibly damaged, photograph the package and the tyre and email ${EMAIL} within 48 hours of delivery so we can arrange a replacement.`]],
    ],
  },
  shipping: {
    title: "Shipping & Delivery Policy",
    intro: "We deliver across India.",
    sections: [
      ["Delivery area and time", ["We ship PAN India. Orders are usually delivered within 7–10 business days of payment confirmation. Remote areas may take slightly longer."]],
      ["Shipping charges", ["A flat shipping fee is shown at checkout and included in your INR total before you pay."]],
      ["Tracking", ["You can check the status and expected delivery date of your order at any time on the Track My Order page using your order number and email address. We will also email you when your order ships."]],
      ["Delivery issues", [`Please make sure your address and phone number are correct. If a delivery fails because of an incorrect address or no one being available, re-delivery charges may apply. Contact ${EMAIL} for any delivery issue.`]],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: `${BRAND} respects your privacy. This policy explains what information we use and why.`,
    sections: [
      ["What we collect", ["When you place an order or contact us, we collect your name, email address, phone number, delivery address and the details of your order or message."]],
      ["How we use it", [
        "Your information is used only to process and deliver your order and to contact you about it or about your enquiry.",
        "We do not sell, rent or share your information for marketing, and we do not send promotional emails.",
      ]],
      ["Payments", ["Payments are handled by Cashfree Payments. Your card, UPI and bank details are entered on Cashfree's secure page and are never received or stored by us."]],
      ["Who we share it with", ["Only the partners needed to complete your order: Cashfree (payment), our courier (delivery) and our email provider (order and support emails)."]],
      ["Cookies", ["We do not use advertising or tracking cookies. Your cart is saved in your own browser so it isn't lost if you leave the page."]],
      ["Your choices", [`To ask what information we hold about you, or to have it corrected or deleted once your order is complete, email ${EMAIL}.`]],
      ["Grievance officer", [`Name: A. Kumar. Location: Gurugram, Haryana, India. Email: ${EMAIL}. We aim to acknowledge complaints within 48 hours and resolve them within one month.`]],
    ],
  },
  contact: {
    title: "Contact Us",
    intro: "We're happy to help with orders, sizing and fitment questions.",
    sections: [
      ["Business", [`${BRAND} is a brand of ${ENTITY}.`, "GSTIN: 06FVBPS5036P1ZZ", `~Registered address: ${ADDRESS}`]],
      ["Email support", [`${EMAIL}. You can also use the support form on our Support page. We reply by email, usually within one business day.`]],
      ["Orders", ["Track your order any time on the Track My Order page."]],
    ],
  },
};

export const POLICY_UPDATED = UPDATED;
